<app-loading [fullScreen]="true" [size]="'medium'" [name]="'full'"></app-loading>
<app-nav-bar id="nv-header" *ngIf="fireAuth.user | async" [menu]="menu"></app-nav-bar>

<div class="ns-body" [class.ns-body-full]="(fireAuth.user | async) === null">
    <router-outlet></router-outlet>
</div>